import { type RecordsQueries, defRecordsQueries } from '@kizen/query/records';
import AxiosService from '__services/AxiosService';

const queries: RecordsQueries = defRecordsQueries(AxiosService);

export const displayNamesQuery: RecordsQueries['displayNamesQuery'] =
  queries.displayNamesQuery;

export const entityRecordQuery: RecordsQueries['entityRecordQuery'] =
  queries.entityRecordQuery;

export const fieldValueQuery: RecordsQueries['fieldValueQuery'] =
  queries.fieldValueQuery;

export const searchEntityRecordsInfiniteQuery: RecordsQueries['searchEntityRecordsInfiniteQuery'] =
  queries.searchEntityRecordsInfiniteQuery;
